import { RootState } from "../store";

export type IFilterLinkOperator = "and" | "or";

export enum FilterOperator {
  Contains = "contains",
  IsAnyOf = "isAnyOf",
  IsEmpty = "isEmpty",
  IsGreaterOrEqualTo = "isGreaterOrEqualTo",
  IsLessOrEqualTo = "isLessOrEqualTo",
  ArrayContains = "arrayContains",
  IsEqualTo = "isEqualTo",
}

export interface IFilterItem<T extends FilterOperator = FilterOperator> {
  id: string;
  name: string;
  operator: T;
  value?: string | number | boolean | string[] | number[] | (string | number)[];
}

export type IFilterItemApi<T extends FilterOperator = FilterOperator> = Omit<IFilterItem<T>, "id">;

export interface IFilters {
  items: IFilterItem[];
  linkOperator: IFilterLinkOperator;
}

export interface ColumnFilterProps {
  tableName: string;
  fieldName: string;
  filterSelectorValue: (state: RootState, fieldName: string) => IFilterItem | undefined;
  filterUpdateAction: (item: IFilterItem) => void;
  operator?: FilterOperator;
}

export interface ReplaceFilterField {
  from: string;
  to: string;
}
